import { Checkbox, DatePicker } from "@ds/ds-snam/react";
import { ICalendarDialogForm, ICalendarDialogFormData,  } from "dataModels/b2b";
import  {  forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import { DATE_FORMAT, DsLayout, UICommand } from "shared/constants";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { onDateInputChange } from "../shared/calendarUtils";
import { useSelector } from "react-redux";
import { RootState } from "state/appStore";

interface RangeCalendarFormProps {
    command: UICommand
}

const defaultFormData : ICalendarDialogFormData = {
    type:-1, 
    startDate:moment.utc(new Date(), DATE_FORMAT).unix(),
    endDate:moment.utc(new Date(), DATE_FORMAT).unix()
}

const RangeCalendarForm= forwardRef<ICalendarDialogForm, RangeCalendarFormProps>((props, ref) => {
    const { t, i18n } = useTranslation(["b2b", "app"]);
    const layoutMode = useSelector((state:RootState)=>{
        return state.dsLayout.mode;
    })

    const localRef  = useRef<HTMLDivElement>(null);
    useImperativeHandle(ref, () => ({
        getFormValues: () => {
            return formData; //qua ritornare il formdata
        }
    }));
    const [formData,setFormData ] = useState<ICalendarDialogFormData>(defaultFormData);
    
    const loadData = ()=>{
        let currentData:ICalendarDialogFormData = formData;
        currentData.startDate=moment.utc(new Date(), DATE_FORMAT).unix();
        currentData.endDate=moment.utc(new Date(), DATE_FORMAT).unix();
        currentData.type=-1;
        switch(props.command){
            case(UICommand.CALENDAR_PUBBLICATION):
                currentData.type=1;
                setFormData(currentData);
            break;
            case(UICommand.CALENDAR_CONFIGURE):
                currentData.type=0;
                setFormData(currentData);
            break;
            case(UICommand.CALENDAR_DELETE_PUBBLICATION):
                currentData = {
                    ...defaultFormData,
                    type: 2,
                    maintainReservations: false // solo in questo caso
                };
                setFormData(currentData);
            break;
            case(UICommand.REVERT_RESERVATIONS):
                currentData.type=4;
                setFormData(currentData);
            break;
            default:
            break;
        }
    }
    useEffect(() => {
        loadData();
    }, []);



    
    return (
        <>  
            <div ref={localRef}>
                
                    <>  
                        <div ref={localRef}>
                            <div slot="title" style={{color:layoutMode===DsLayout.DARK_MODE?"white":"black"}}>
                                {props.command===UICommand.CALENDAR_PUBBLICATION &&
                                    <>
                                        <h2 className="ff-ubuntu ff-title-s ff-bold" style={{ margin: "0 auto",width:'fit-content',textAlign:'center',marginLeft:'35px',marginRight:'35px' }} id="overlay-title">
                                            {t('calendar.popups.pubblication.0')}{/*Scegli l'intervallo temporale di pubblicazione del Calendario*/}
                                        </h2>
                                        <p style={{ margin: "0 auto",textAlign:'center',marginTop:'20px' }}>{t('calendar.popups.pubblication.1')}{/*Inserisci l'intervallo temporale</p>*/}</p>
                                        <p style={{ margin: "0 auto",textAlign:'center',marginTop:'10px',marginLeft:'150px',marginRight:'150px' }}>{t('calendar.popups.pubblication.2')}{/*Verranno pubblicati gli slot configurati nel calendario provvisorio.*/}</p>
                                    </>
                                }
                                {props.command===UICommand.CALENDAR_CONFIGURE &&
                                    <>
                                        <h2 className="ff-ubuntu ff-title-s ff-bold" style={{ margin: "0 auto",width:'fit-content',textAlign:'center',marginLeft:'35px',marginRight:'35px' }} id="overlay-title">
                                            {t('calendar.popups.configure.0')}{/*Scegli l'intervallo temporale di configurazione del Calendario*/}
                                        </h2>
                                        <p style={{ margin: "0 auto",textAlign:'center',marginTop:'20px' }}>{t('calendar.popups.configure.1')}{/*Inserisci l'intervallo temporale*/}</p>
                                    </>
                                }
                                {props.command===UICommand.CALENDAR_DELETE_PUBBLICATION &&
                                    <>
                                        <h2 className="ff-ubuntu ff-title-s ff-bold" style={{ margin: "0 auto",width:'fit-content',textAlign:'center',marginLeft:'35px',marginRight:'35px' }} id="overlay-title">
                                            {t('calendar.popups.delete.0')}{/*Scegli l'intervallo temporale di slot pubblicati da eliminare*/}
                                        </h2>
                                        <p style={{ margin: "0 auto",textAlign:'center',marginTop:'20px' }}>{t('calendar.popups.delete.1')}{/*Inserisci l'intervallo temporale*/}</p>
                                        <p style={{ margin: "0 auto",textAlign:'center',marginTop:'10px',marginLeft:'',marginRight:''/*,marginBottom:'-12px' */}}>{t('calendar.popups.delete.3')}</p>
                                        <p style={{ margin: "0 auto",textAlign:'center',marginTop:'',marginLeft:'',marginRight:'' }}>{t('calendar.popups.delete.4')}</p>
                                    </>
                                }
                                {props.command===UICommand.CALENDAR_NON_WORKING_DAYS_INSERT &&
                                    <>
                                        <h2 className="ff-ubuntu ff-title-s ff-bold" style={{ margin: "0 auto",width:'fit-content',textAlign:'center',marginLeft:'35px',marginRight:'35px' }} id="overlay-title">
                                            {t('calendar.popups.nonWorkingDays.0')}
                                        </h2>
                                        <p style={{ margin: "0 auto",textAlign:'center',marginTop:'20px' }}>{t('calendar.popups.nonWorkingDays.1')}</p>
                                    </>
                                }
                                {props.command===UICommand.CALENDAR_NON_WORKING_DAYS_DELETE &&
                                    <>
                                        <h2 className="ff-ubuntu ff-title-s ff-bold" style={{ margin: "0 auto",width:'fit-content',textAlign:'center',marginLeft:'35px',marginRight:'35px' }} id="overlay-title">
                                            {t('calendar.popups.nonWorkingDays.2')}
                                        </h2>
                                        <p style={{ margin: "0 auto",textAlign:'center',marginTop:'20px' }}>{t('calendar.popups.nonWorkingDays.3')}</p>
                                    </>
                                }
                                {props.command===UICommand.REVERT_RESERVATIONS &&
                                    <>
                                        <h2 className="ff-ubuntu ff-title-s ff-bold" style={{ margin: "0 auto",width:'fit-content',textAlign:'center'}} id="overlay-title">
                                            {t('calendar.popups.revert.0')}
                                        </h2>
                                        <p style={{ margin: "0 auto",textAlign:'center',marginTop:'20px' }}>{t('calendar.popups.revert.1')}</p>
                                    </>
                                }
                            </div>
                            {props.command===UICommand.CALENDAR_DELETE_PUBBLICATION &&
                            <div slot="text" style={{ background:'',margin:'0 auto',width:'fit-content',marginTop:'30px'}}>
                                <Checkbox
                                    checkboxId="maintainReservations"
                                    checkboxStatus="default"
                                    checkboxLabel={t('calendar.popups.delete.5')}
                                    elementResetPair=""
                                    isDisabled={false}
                                    isChecked={formData.maintainReservations}
                                    isRequired={false}
                                    onCheckboxChange={(event:Event)=>{
                                        let currentData:ICalendarDialogFormData = formData;
                                        console.log((event as CustomEvent).detail.checkbox.checked)

                                        currentData.maintainReservations = (event as CustomEvent).detail.checkbox.checked;
                                        setFormData(currentData);
                                    }}>
                                </Checkbox> 
                            </div>
                            }
                            <div slot="text" style={{ background:'',margin:'0 auto',width:'fit-content',marginTop:'30px'}}>
                                <DatePicker
                                    id="endDate"
                                    datePickerTitle={t('calendar.popups.pubblication.3')}//"Dal*/al*" //
                                    isRangePicker={true}
                                    datePickerVariant="full-date"
                                    datePickerPlaceholder=""
                                    startingYear={1990}
                                    endingYear={2099}
                                    defaultDate={new Date()}
                                    disabledDates={props.command!==UICommand.REVERT_RESERVATIONS ? { lastDisabledDate: new Date() } : {}}
                                    isDisabled={false}
                                    datePickerStatus="default"
                                    confirmButtonLabel={t('calendar.popups.buttons.8')}//"Conferma"
                                    hasCloseButton={false}
                                    isReadonly={false}
                                    onDateSelection={(event: Event) => {
                                        let currentData:ICalendarDialogFormData = formData;
                                        let currentFormData = onDateInputChange(event,currentData);
                                        setFormData(currentFormData)
                                    }}
                                ></DatePicker> 
                            </div>
                        </div>
                    </>
            </div>
        </>
    );
});
export default RangeCalendarForm;